import { atomWithToggle } from "./utils";

export const isSearchFiltersPanelOpenAtom = atomWithToggle(false);
isSearchFiltersPanelOpenAtom.debugLabel = "Search Filters Panel Atom";
